import styles from './Menu.module.css'
import { Container, Nav, Navbar } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { Context as UserContext } from '../../../../contexts/UserContext'
import { MouseEventHandler, useContext } from 'react'
import MainButton from '../../../../components/buttons/nav-button/MainButton'

export default function Menu() {
    const { username } = useContext(UserContext)
    const navigate = useNavigate()
    const location = useLocation()

    const path = location.pathname
    const menuPrefix = "/admin/dashboard"

    const trimLastCharIf = (uri: string, suffix: string) => {
        if(uri.charAt(uri.length - 1) === suffix) {
            return uri.substring(0, uri.length - 1)
        }

        return uri
    }

    const checkIfActive = (uri: string) => trimLastCharIf(path, '/') === trimLastCharIf(uri, '/')

    const logout: MouseEventHandler<HTMLElement> = (e) => {
        e.preventDefault()

        localStorage.removeItem(process.env.REACT_APP_SESSION_TOKEN_NAME)
        navigate('/admin')
    }

    return (
        <Navbar expand="lg">
            <Container fluid className={ styles.navbarContainer }>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="m-auto gap-4">

                        <MainButton
                            active={checkIfActive(`${menuPrefix}/users`)}
                            title={"Felhasználók listázása"}
                            onClick={(e) => {
                                e.preventDefault()
                                navigate(`${menuPrefix}/users`)
                            }}
                        />

                        <MainButton
                            active={checkIfActive(`${menuPrefix}/`)}
                            title={"VPN felhasználók listázása"}
                            onClick={(e) => {
                                e.preventDefault()
                                navigate(`${menuPrefix}/`)
                            }}
                        />

                        <MainButton
                            active={checkIfActive(`${menuPrefix}/system-parameters`)}
                            title={"Rendszer paraméterek"}
                            onClick={(e) => {
                                e.preventDefault()
                                navigate(`${menuPrefix}/system-parameters`)
                            }}
                        />

                        <MainButton
                            active={checkIfActive(`${menuPrefix}/logs`)}
                            title={"Naplózott bejelentkezések"}
                            onClick={(e) => {
                                e.preventDefault()
                                navigate(`${menuPrefix}/logs`)
                            }}
                        />

                        <MainButton
                            active={false}
                            title={`Kilépés (${username})`}
                            onClick={logout}
                        />
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}